import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    {...props}
    width={21}
    height={26}
    viewBox={'0 0 20 34'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Path
      stroke={props.fill || '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.97}
      d="M9.17 25.19c-.79-3.11-.69-3.5-2.53-5.96-1.36-1.82-2.34-3.85-3.58-6.02-.48-.83-.2-1.89.63-2.37.83-.48 1.89-.19 2.37.63.56.97 1.12 1.94 1.68 2.92.4.6 1.44.11 1.42-.5V3.33c0-.76.62-1.38 1.37-1.38.75 0 1.38.62 1.38 1.38v6.42c0-.76.62-1.38 1.37-1.38.75 0 1.37.62 1.37 1.38v.64a1.374 1.374 0 1 1 2.75 0v1.29a1.374 1.374 0 1 1 2.75 0c.27 3.28.54 5.97-.64 8.32-.77 1.91-.96 3.1-1.52 5.21"
    />
    <Path
      stroke={props.fill || '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.97}
      d="M9.17 25.19c-.79-3.11-.69-3.5-2.53-5.96-1.36-1.82-2.34-3.85-3.58-6.02-.48-.83-.2-1.89.63-2.37.83-.48 1.89-.19 2.37.63.56.97 1.12 1.94 1.68 2.92.4.6 1.44.11 1.42-.5V3.33c0-.76.62-1.38 1.37-1.38.75 0 1.38.62 1.38 1.38v6.42c0-.76.62-1.38 1.37-1.38.75 0 1.37.62 1.37 1.38v.64a1.374 1.374 0 1 1 2.75 0v1.29a1.374 1.374 0 1 1 2.75 0c.27 3.28.54 5.97-.64 8.32-.77 1.91-.96 3.1-1.52 5.21M13.85 2.35h6.03L17.87 1"
    />
    <Path
      stroke={props.fill || '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.97}
      d="M13.85 2.35h6.03L17.87 1M19.88 2.35l-2.01 1.34M19.88 2.35l-2.01 1.34M7.03 2.35H1L3.01 1"
    />
    <Path
      stroke={props.fill || '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.97}
      d="M7.03 2.35H1L3.01 1M1 2.35l2 1.34M1 2.35l2 1.34"
    />
  </Svg>
);
export default SvgComponent;
